module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_8003.ec31d45f.png";